export default __webpack_public_path__ + "static/media/790246033078353950.89cd7056.png";